module.exports = __webpack_public_path__ + "img/symbol_1.5c678977.png";